import { lazy, useEffect } from 'react'

import { type RouteComponentProps } from 'react-router'

import { type IBreadcrumbsProps } from '@webapp/core/components/Breadcrumbs'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import { BillListPageStatuses } from '@webapp/pages/BillListPage'
import messages from './messages'

export interface BillCreatePageParams {
  uuid?: uuid
}

const BillCreateContainerChunk = lazy(() =>
  import('../containers/BillCreateContainer').then(
    ({ BillCreateContainer }) => ({
      default: BillCreateContainer,
    })
  )
)

export const BillCreatePage = (
  props: RouteComponentProps<BillCreatePageParams>
) => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const AP_10424_SIDE_BY_SIDE_VIEW = useFeatureFlag(
    'AP_10424_SIDE_BY_SIDE_VIEW'
  )

  useEffect(() => {
    window.analytics?.page({ sideBySide: AP_10424_SIDE_BY_SIDE_VIEW })
  }, [AP_10424_SIDE_BY_SIDE_VIEW])

  const breadcrumbs = (
    AP_10424_SIDE_BY_SIDE_VIEW
      ? []
      : [
          {
            name: intl.formatMessage(messages.manageBillsPageTitle),
            link: url('BillListPage', {
              status: BillListPageStatuses.DRAFT,
            }),
          },
          { name: intl.formatMessage(messages.billCreatePageTitle) },
        ]
  ) satisfies IBreadcrumbsProps['crumbs']

  return (
    <Page
      pageTitle={intl.formatMessage(messages.billCreatePageTitle)}
      breadcrumbs={breadcrumbs}
    >
      <BillCreateContainerChunk billUUID={props.match.params?.uuid} />
    </Page>
  )
}
